import React from 'react';
import MembershipCrawlTemplate from '../../components_membership_hotel/template/hotel/membershipCrawlTemplate';
class MembershipCrawl extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    };

    render() {

        return (
            <div>
                <MembershipCrawlTemplate
                    state={this.state}
                />
            </div>
        )
    }
}
export default MembershipCrawl;